module.exports = __webpack_public_path__ + "static/media/social.ef487265.png";